import React, { useState } from "react";
import { Button, Input, Space } from "antd";

export interface SearchBoxProps {
  onSearch: (value?: string) => void;
}

const SearchBox: React.FC<SearchBoxProps> = (props) => {
  const [value, setValue] = useState<string>();

  return (
    <Space>
      <Input placeholder="请输入搜索内容" value={value} onChange={(e) => setValue(e.currentTarget.value)} />
      <Button type="primary" onClick={() => props.onSearch(value)}>
        搜索
      </Button>
      <Button
        onClick={() => {
          props.onSearch();
          setValue(undefined);
        }}
      >
        重置
      </Button>
    </Space>
  );
};

export default SearchBox;
